import { Box, Tabs } from '@shopify/polaris';

type Tab = {
  id: string;
  content: string;
  accessibilityLabel?: string;
};

type ModalTabsProps = {
  tabs: Tab[];
  selected: number;
  fitted?: boolean;
  onSelect: (index: number) => void;
};

const ModalTabs = ({ tabs, selected, fitted = false, onSelect }: ModalTabsProps) => {
  return (
    <Box>
      <Tabs tabs={tabs} selected={selected} onSelect={onSelect} fitted={fitted} />
    </Box>
  );
};

export default ModalTabs;
